import { Dispatch } from 'react';

/**
 * The key used to define the function name of the action creator
 * to avoid problems with minification during the build process.
 */
export const ACTION_CREATOR_NAME = 'ACTION_CREATOR_NAME';

export function generateDispatchToPropsMap<T>(dispatch: Dispatch<any>, functions: Function[]): T {
    const props = {};
    functions.forEach(f => {
        props[f[ACTION_CREATOR_NAME]] = (...args: any[]) => dispatch(f(...args));
    });

    return props as T;
}